export const CREATE_SUCCESS_STORY_SUCCESS = "success_story/create_success_story_success";
export const CREATE_SUCCESS_STORY_FAIL = "success_story/create_success_story_fail";

export const UPDATE_SUCCESS_STORY_SUCCESS = "success_story/update_success_story_success";
export const UPDATE_SUCCESS_STORY_FAIL = "success_story/update_success_story_fail";

export const GET_SUCCESS_STORY_SUCCESS = "success_story/get_success_story_success";
export const GET_SUCCESS_STORY_FAIL = "success_story/get_success_story_fail";

export const DELETE_SUCCESS_STORY_SUCCESS = "success_story/delete_success_story_success";
export const DELETE_SUCCESS_STORY_FAIL = "success_story/delete_success_story_fail";